import {defineConfig, defineRecipe} from "@chakra-ui/react";

export const buttonRecipe = defineRecipe({
    base: {
        borderRadius: "full", // Oval shape
        //fontWeight: "bold",
        bg: "{colors.primary}", // Primary background color
        color: "{colors.onPrimary}", // Text color
        px: "24px", // Horizontal padding for more width
        py: "10px", // Vertical padding for more height
        _hover: {
            bg: "{colors.secondary}", // Secondary color on hover
            color: "{colors.onSecondary}", // Text color on hover
        },
        _active: {
            bg: "{colors.secondary}",
            transform: "scale(0.95)", // Slight shrink on active
        },
    },
    sizes: {
        lg: {
            px: "32px", // Extra padding for large size
            py: "20px",
            fontSize: "lg", // Larger font size
        },
    },
    defaultVariants: {
        size: "lg", // Set the default size to large
    },
});

const themeConfig = defineConfig({
    theme: {
        tokens: {
            colors: {
                primary: { value: "#4CAD33" },
                onPrimary: { value: "#FFFFFF" },
                secondary: { value: "#4682B4" },
                onSecondary: { value: "#FFFFFF" },
                background: { value: "#F0F4F3" },
                onBackground: { value: "#333333" },
                brand: {
                    green: {
                        50: "#F0F9F0",
                        100: "#E9F7E6", // pale highlighter
                        500: "#4CAD33", // your logo green
                        600: "#3B8C28", // darker hover
                    },
                    blue: {
                        50: "#EEF1FA",
                        100: "#DDE0F5",
                        500: "#26267D", // your logo blue
                    },
                },
            },
            fonts: {
                heading: { value: "'Roboto', sans-serif" },
                body: { value: "'Roboto', sans-serif" },
            },
            space: {
                small: { value: "8px" },
                medium: { value: "16px" },
                large: { value: "24px" },
            },
        },
        recipes: {
            button: buttonRecipe,
        },
    },
});

export default themeConfig;
